import React, { useRef } from 'react';
import styles from './Testimonials.module.css';

const testimonials = [
  {
    name: 'Marcus Tan',
    // company: 'Orion Fintech Pte Ltd',
    location: 'Singapore',
    industry: 'Fintech',
    year: 2024,
    quote:
      'BETA Edge rebuilt our core payments platform ahead of schedule. Their engineering discipline and communication were outstanding.',
  },
  {
    name: 'Aroha Ngata',
    // company: 'Kauri Logistics Group',
    location: 'New Zealand',
    industry: 'Logistics',
    year: 2023,
    quote:
      'The automation workflows they built cut our dispatch processing time in half. A genuinely dependable delivery team.',
  },
  {
    name: 'Kenji Watanabe',
    // company: 'Sakura Manufacturing Corp',
    location: 'Japan',
    industry: 'Manufacturing',
    year: 2025,
    quote:
      'Precise, well-documented ERP integration work. BETA Edge understood our quality standards from day one.',
  },
  {
    name: 'Ritika Sharma',
    // company: 'Nova Health Systems',
    location: 'India',
    industry: 'Healthcare',
    year: 2023,
    quote:
      'Their team delivered a HIPAA-ready patient portal with excellent attention to security and usability.',
  },
  {
    name: 'Aiman Haziq',
    // company: 'Meridian Retail Sdn Bhd',
    location: 'Malaysia',
    industry: 'Retail & E-commerce',
    year: 2024,
    quote:
      'Our online storefront now handles peak season traffic without a hitch. Reliable partners from planning to launch.',
  },
  {
    name: 'Oliver Bennett',
    // company: 'Thames Capital Advisors',
    location: 'UK',
    industry: 'Business Consulting',
    year: 2025,
    quote:
      'BETA Edge brought clarity to a messy legacy system and delivered a roadmap we could actually execute on.',
  },
  {
    name: 'Sophie Tremblay',
    // company: 'Maple Grid Energy',
    location: 'Canada',
    industry: 'Energy & Utilities',
    year: 2023,
    quote:
      'The custom analytics dashboard they built gives our engineers real-time visibility across every substation.',
  },
  {
    name: 'Daniel Whitfield',
    // company: 'Summit Insurance Partners',
    location: 'USA',
    industry: 'Insurance',
    year: 2026,
    quote:
      'From underwriting automation to claims workflows, BETA Edge modernized systems we had been putting off for years.',
  },
  {
    name: 'Priya Nair',
    company: 'Vantage Enterprise Solutions',
    location: 'India',
    industry: 'IT Consulting',
    year: 2026,
    quote:
      'A true extension of our team. Their INR-based billing also gave us predictable budgeting all year round.',
  },
  {
    name: 'Grace Lim',
    // company: 'Harbourfront Digital',
    location: 'Singapore',
    industry: 'Digital Marketing',
    year: 2025,
    quote:
      'They rebuilt our marketing stack and improved our lead pipeline visibility within the first quarter.',
  },
  {
    name: 'Liam O\u2019Connor',
    // company: 'Northbridge Software Group',
    location: 'UK',
    industry: 'Software Development',
    year: 2024,
    quote:
      'Consistently high code quality and clear sprint reporting. One of the more transparent teams we have worked with.',
  },
  {
    name: 'Hana Kobayashi',
    // company: 'Tokyo Cloud Dynamics',
    location: 'Japan',
    industry: 'Cloud & SaaS',
    year: 2024,
    quote:
      'Migrating our platform to a cloud-native architecture was seamless thanks to their structured delivery process.',
  },
  {
    name: 'Nathan Reyes',
    // company: 'Pacific Rim Startups Inc.',
    location: 'USA',
    industry: 'Business Setup & Startups',
    year: 2023,
    quote:
      'BETA Edge helped us go from idea to MVP in under three months, with quality that impressed our investors.',
  },
  {
    name: 'Farah Zulkifli',
    // company: 'Straits Business Consulting',
    location: 'Malaysia',
    industry: 'Enterprise Solutions',
    year: 2026,
    quote:
      'Their enterprise systems overhaul reduced manual reporting work across three regional offices.',
  },
  {
    name: 'Emily Carter',
    // company: 'Northern Lights Analytics',
    location: 'Canada',
    industry: 'Business Analytics',
    year: 2025,
    quote:
      'Sharp analytics work and a team that genuinely cares about the outcome, not just the deliverable.',
  },
];

const StarRating = () => (
  <div className={styles.stars} aria-label="5 out of 5 stars">
    {Array.from({ length: 5 }).map((_, i) => (
      <span key={i} className={styles.star}>
        {'\u2605'}
      </span>
    ))}
  </div>
);

const Testimonials = () => {
  const scrollRef = useRef(null);

  const scrollByCard = (direction) => {
    const el = scrollRef.current;
    if (!el) return;
    const cardWidth = el.querySelector(`.${styles.card}`)?.offsetWidth || 280;
    el.scrollBy({ left: direction * (cardWidth + 18), behavior: 'smooth' });
  };

  return (
    <section className={styles.wrapper} aria-labelledby="testimonials-heading">
      <div className={styles.headingBlock}>
        <h2 id="testimonials-heading" className={styles.title}>
          Trusted by Clients Across the Globe
        </h2>
        <p className={styles.subtitle}>
          15 verified 5-star reviews from clients in Singapore, New Zealand, Japan,
          India, Malaysia, the UK, Canada and the USA (2023&ndash;2026).
        </p>
      </div>

      <div className={styles.scrollShell}>
        <button
          type="button"
          className={`${styles.scrollBtn} ${styles.scrollBtnLeft}`}
          onClick={() => scrollByCard(-1)}
          aria-label="Scroll testimonials left"
        >
          &#8249;
        </button>

        <div className={styles.scrollRow} role="list" ref={scrollRef}>
        {testimonials.map((t, idx) => (
          <article
            key={idx}
            className={styles.card}
            role="listitem"
            itemScope
            itemType="https://schema.org/Review"
          >
            <div itemProp="itemReviewed" itemScope itemType="https://schema.org/Organization">
              <meta itemProp="name" content="BETA Edge" />
              <meta itemProp="url" content="https://www.beta-edge.com" />
            </div>

            <div itemProp="reviewRating" itemScope itemType="https://schema.org/Rating">
              <meta itemProp="ratingValue" content="5" />
              <meta itemProp="bestRating" content="5" />
              <StarRating />
            </div>

            <p className={styles.quote} itemProp="reviewBody">
              &ldquo;{t.quote}&rdquo;
            </p>

            <div className={styles.meta}>
              <p
                className={styles.clientName}
                itemProp="author"
                itemScope
                itemType="https://schema.org/Person"
              >
                <span itemProp="name">{t.name}</span>
              </p>
              <p className={styles.clientCompany}>{t.company}</p>
              <div className={styles.tagRow}>
                <span className={styles.tag}>{t.location}</span>
                <span className={styles.tag}>{t.industry}</span>
                <span className={styles.tagYear} itemProp="datePublished">
                  {t.year}
                </span>
              </div>
            </div>
          </article>
        ))}
        </div>

        <button
          type="button"
          className={`${styles.scrollBtn} ${styles.scrollBtnRight}`}
          onClick={() => scrollByCard(1)}
          aria-label="Scroll testimonials right"
        >
          &#8250;
        </button>
      </div>
    </section>
  );
};

export default Testimonials;